export enum AnalyticsSourceValues {
  PATIENT_CALENDAR_TAB = 'Patient Calendar Tab',
  PATIENT_CLINICAL_PROFILE_TAB = 'Patient Clinical Profile Tab',
  CALENDAR_TAB = 'Calendar Tab',
  CARE_PLAN_TAB = 'Care Plan Tab',
  DISCHARGE_PLAN_TAB = 'Discharge Plan Tab',
  INQUIRY_DETAILS = 'Inquiry Details',
  INQUIRY_ADMISSIONS_CONSULTATION = 'Inquiry Admissions Consultation',
  CLINICAL_PROFILE_TAB = 'Clinical Profile Tab',
  DOCUMENTS_TAB = 'Documents Tab',
  PATIENT_TAB = 'Patient Tab',
  TASKS_TAB = 'Tasks Tab',
  PATIENT_CALENDAR_TAB_MODAL = 'Patient Calendar Tab Modal',
  CALENDAR_TAB_MODAL = 'Calendar Tab Modal',
  ACTION_MENU = 'Action Menu',
  DOCUMENT_CENTER = 'Document Center',
  OVERVIEW_TAB = 'Overview Tab',
  PATIENT_HEADER = 'Patient Header',
  CALENDAR_GROUPS_TAB = 'Calendar Groups Tab',
  CALENDAR_GROUP_SECTION_TAB = 'Calendar Group Section Tab',
  ALL_GROUPS_SUBTAB = 'All groups subtab',
  ARCHIVE_SUBTAB = 'Archive subtab',
  REGISTER_USER_FOR_GROUP_FLOW = 'Register user for group - registration flow',
  PROFILE_TAB_MAUD = 'Profile Tab Maud',
  PROFILE_TAB_ADMIN = 'Profile Tab Admin',
  SCHEDULE_APPOINTMENT_MODAL = 'Schedule Appointment Modal',
  LABS_TAB = 'Labs Tab',
  PATIENT_MESSAGES_TAB = 'Patient Messages Tab',
  MESSAGES_MENU = 'Messages Menu',
  MAUD_LEFT_NAV = 'Maud Left Nav',
  TASKS_LIST_PANEL = 'Tasks List Panel',
  PATIENT_CHART_NAVIGATION = 'Patient Chart Navigation',
  SESSION_GUIDE = 'Session Guide',
  NOTES_TAB = 'Notes Tab',
  NOTE_FORM = 'Note Form',
  TASK_FORM = 'Task Form',
  SMT_TAB = 'SMT Tab',
  GLOBAL = 'Global',
  PATIENT_LIST = 'Patient List',
  PROVIDER_DASHBOARD = 'Provider Dashboard',
}
